module.exports = __webpack_public_path__ + "static/media/icon_step_03.467ad689.webp";